import { useState, useEffect } from 'react';

import { useGlobalDialog } from "../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';

import { useCompanyUsersHook } from '../../Hooks/Companies/companyUsersHooks';

import { CompanyUser, AddEditCompanyUsersModalInterface } from '../../Models/Company/CompanyUser';

import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import QueryBuilderHelper from '../../Utilities/Helpers/QueryBuilderHelper';

import { CompanyUserField } from '../../Utilities/Enums/ParametersEnum';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { CachingEnum } from '../../Utilities/Enums/CachingEnum';

import FormTextField from '../../CustomViews/Elements/FormTextField';
import CustomButton from '../../CustomViews/Elements/CustomButton';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    width: 40vw;
`;

export default function AddEditCompanyUserModal(props: AddEditCompanyUsersModalInterface) {
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    const { enqueueSnackbar } = useSnackbar();
    let { companyUsersFormData, setcompanyUsersFormData, openAddEditCompanyUserModal, setopenAddEditCompanyUserModal, companyid, getCompanyData } = props;
    let requiredFields = RequiredParametersHelper.companyUser();

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});
    let [queryStr, setQueryStr] = useState({
        pageSize: 10,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
        id: companyid,
    });

    let q_queryKey = [CachingEnum.COMPANY_USERS, queryStr]
    let { createCompanyUser, editCompanyUserById } = useCompanyUsersHook(q_queryKey, queryStr, false);

    const nameProps = {
        name: CompanyUserField.NAME,
        title: 'Name',
        fieldValue: companyUsersFormData?.[CompanyUserField.NAME] ?? "",
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == CompanyUserField.NAME)?.keyName != null,
        disabled: true,
        // hideLabel: true,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            if(setcompanyUsersFormData) {
                setcompanyUsersFormData(prev => ({ ...prev, [CompanyUserField.NAME]: selectedValue }));
            }
        },
    },
        firstNameProps = {
            name: CompanyUserField.FIRST_NAME,
            title: 'First Name',
            fieldValue: companyUsersFormData?.[CompanyUserField.FIRST_NAME] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CompanyUserField.FIRST_NAME)?.keyName != null,
            // disabled: viewType != ViewType.ADD,
            // hideLabel: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _formData = { ...companyUsersFormData, [CompanyUserField.FIRST_NAME]: selectedValue };

                updateName(_formData);
            },
        },
        lastNameProps = {
            name: CompanyUserField.LAST_NAME,
            title: 'Last Name',
            fieldValue: companyUsersFormData?.[CompanyUserField.LAST_NAME] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CompanyUserField.LAST_NAME)?.keyName != null,
            // disabled: viewType != ViewType.ADD,
            // hideLabel: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _formData = { ...companyUsersFormData, [CompanyUserField.LAST_NAME]: selectedValue };

                updateName(_formData);
            },
        },
        employeeCodeProps = {
            name: CompanyUserField.EMPLOYEE_CODE,
            title: 'Employee Code',
            fieldValue: companyUsersFormData?.[CompanyUserField.EMPLOYEE_CODE] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CompanyUserField.EMPLOYEE_CODE)?.keyName != null,
            // disabled: viewType != ViewType.ADD,
            // hideLabel: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setcompanyUsersFormData) {
                    setcompanyUsersFormData(prev => ({ ...prev, [CompanyUserField.EMPLOYEE_CODE]: selectedValue }));
                }
            },
        },
        usernameProps = {
            name: CompanyUserField.USERNAME,
            title: 'Username',
            fieldValue: companyUsersFormData?.[CompanyUserField.USERNAME] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CompanyUserField.USERNAME)?.keyName != null,
            // disabled: viewType != ViewType.ADD,
            // hideLabel: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setcompanyUsersFormData) {
                    setcompanyUsersFormData(prev => ({ ...prev, [CompanyUserField.USERNAME]: selectedValue }));
                }
            },
        },
        databaseIdProps = {
            name: CompanyUserField.DATABASE_ID,
            title: 'Database Id',
            fieldValue: companyUsersFormData?.[CompanyUserField.DATABASE_ID] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == CompanyUserField.DATABASE_ID)?.keyName != null,
            // disabled: viewType != ViewType.ADD,
            // hideLabel: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setcompanyUsersFormData) {
                    setcompanyUsersFormData(prev => ({ ...prev, [CompanyUserField.DATABASE_ID]: selectedValue }));
                }
            },
        };

    //Event Handlers
    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenAddEditCompanyUserModal) {
            setopenAddEditCompanyUserModal(false);
        }

        if(setcompanyUsersFormData) {
            setcompanyUsersFormData(new CompanyUser());
        }

        setOpenGlobalDialog(false);
    }

    const updateName = async (_formData: any) => {
        let _firstName = _formData?.[CompanyUserField.FIRST_NAME] ?? "";
        let _lastName = _formData?.[CompanyUserField.LAST_NAME] ?? "";
        let _fullName = _firstName + " " + _lastName;

        if(setcompanyUsersFormData) {
            setcompanyUsersFormData({..._formData, [CompanyUserField.NAME]: _fullName});
        }
    }

    const handleSubmit = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, companyUsersFormData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        let _success: boolean = false;

        if(!companyUsersFormData?.[CompanyUserField.PUBLIC_ID]) {
            let createResponse = await createCompanyUser(JSON.stringify(companyUsersFormData));
            
            _success = createResponse?.isSuccess ?? false;
        } else {
            let editResponse = await editCompanyUserById(companyUsersFormData?.[CompanyUserField.PUBLIC_ID], JSON.stringify(companyUsersFormData));
            
            _success = editResponse?.isSuccess ?? false;
        }

        if(_success) {
            onCloseDialog();

            if(getCompanyData) {
                getCompanyData();
            }
        }
    }

    useEffect(() => {
        if(openAddEditCompanyUserModal) {
            setDialogContent({
                title: (!companyUsersFormData?.[CompanyUserField.PUBLIC_ID] ? "Add" : "Edit") + " User",
                // subtitle: (companyUsersFormData?.[CompanyUserField.PUBLIC_ID] ? companyUsersFormData?.userName ?? "" : ""),
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                actionButtons: renderActionButtons(),
                children: renderDialogContent(),
            });
        }
    }, [openAddEditCompanyUserModal, companyUsersFormData, errorMessages]);

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Close'
                onClick={(e: any) => {
                    onCloseDialog(e);
                }} />

            <CustomButton
                btnType={ButtonType.SUCCESS}
                title='Save'
                onClick={(e: any) => {
                    handleSubmit();
                }} />
        </>
    }

    const renderDialogContent = () => {
        return <ModalContentContainer>
            <FormTextField {...firstNameProps} />
            <FormTextField {...lastNameProps} />
            <FormTextField {...nameProps} />
            <FormTextField {...employeeCodeProps} />
            <FormTextField {...usernameProps} />
            <FormTextField {...databaseIdProps} />
        </ModalContentContainer>
    }

    return <></>
}
